import { createContext, useContext } from "react";

import { useDevWarnOnce } from "../../utils/useDevWarnOnce";

export interface FieldContextValue {
  controlId: string;
  /** Id of the rendered `<label>`, present only when the Field has a label. */
  labelId?: string;
  disabled: boolean;
}

const FieldContext = createContext<FieldContextValue | null>(null);

export const FieldContextProvider = FieldContext.Provider;

export function useFieldContext(): FieldContextValue | null {
  return useContext(FieldContext);
}

export function useFieldControl({
  componentName,
  id,
  disabled = false,
}: {
  componentName: string;
  id?: string;
  disabled?: boolean;
}): { controlId?: string; labelId?: string; disabled: boolean } {
  const field = useFieldContext();

  useDevWarnOnce(
    field !== null && id !== undefined,
    `[c6] <${componentName} id={...}> is ignored inside <Field>. Put \`id\` on <Field> instead.`,
  );

  return {
    controlId: field?.controlId ?? id,
    labelId: field?.labelId,
    disabled: (field?.disabled ?? false) || disabled,
  };
}
